<template>
  <div class="attr-list">
    <el-form>
      <el-form-item label="背景颜色">
        <el-color-picker
          v-model="curComponent.style.background"
          show-alpha
        />
      </el-form-item>
      <el-form-item label="方向">
        <el-radio
          v-model="curComponent.style.direction"
          label="vertical"
          @change="directionChange"
        >竖版</el-radio>
        <el-radio
          v-model="curComponent.style.direction"
          label="horizontal"
          @change="directionChange"
        >横版</el-radio>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  components: {},
  computed: {
    curComponent() {
      return this.$store.state.compose.curComponent
    }
  },
  methods: {
    directionChange(e) {
      const width = this.curComponent.style.width
      const height = this.curComponent.style.height
      // if (e === 'vertical') {
      this.curComponent.style.width = height
      this.curComponent.style.height = width
      // }
    }
  }
}
</script>
